import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { StyledControl } from '../../../../common/ui/picker/styled';
export var Control = function Control(_ref) {
  var children = _ref.children,
      innerProps = _ref.innerProps,
      innerRef = _ref.innerRef;
  return /*#__PURE__*/React.createElement(StyledControl, _extends({
    innerRef: innerRef === null ? undefined : innerRef
  }, innerProps), children);
};